import { useState, useEffect } from 'react';
import moment from 'moment';
import { ReactComponent as ProfilePicture } from '@Assets/blankProfile.svg';
import { BsDownload as Download } from 'react-icons/bs';
import { ReactComponent as WhatsAppLogo } from '@Assets/whatsAppDigitalGlyphGreen.svg';
import UserInfoService from '@Helpers/URLHelpers/UserInfoService';
import FileService from '@Helpers/URLHelpers/FileService';
import ErrorHandler from '@Root/ErrorHandler';
import fileDownload from 'js-file-download';
import Avatar from '@mui/material/Avatar';
import Skeleton from '@mui/material/Skeleton';
import { useReduxFileStorage } from '@Hooks/reduxFileStorageHook/useReduxFileStorage';
import { useReduxActiveUser } from '@Hooks/reduxActiveUserHook/useReduxActiveUser';
import '@Partials/_ComStyles.scss';
import './Comment.scss';

export default function Comment(props) {

    const [comment, setComment] = useState({});
    const [commentUser, setCommentUser] = useState({})
    const [commentLoading, setCommentLoading] = useState(true);
    const [activeUser, setActiveUser] = useState({});
    const [file, setFile] = useState();
    const colorList = ['#2784B9', '#40c47d', '#FDB16C', '#b06060', '#f77474', '#6080b0', '#9a60b0', '#6cb060',
            '#b0ae60', '#65412b', '#cc9963', '#e1bd83', '#60748b', '#744700', '#c8d579', '#5f8fba', '#3e6073', '#8e6dc1', '#473785',
           '#9158a9',  '#7f3f7a', '#583e84', '#073763', '#20124d', '#3d124d', '#64113f', '#780448', '#003e23', '#108764', '#1a4c3d',
            '#c8d77f', '#11888b', '#1a95bd', '#0d6c7b', '#25b56e', '#006e3d'];
    const userInfoService = new UserInfoService();
    const { activeUserId } = useReduxActiveUser();
    const { currentFiles, downloadFileFromUrl } = useReduxFileStorage();
    const fileService = new FileService();
    const errorHandler = new ErrorHandler();
    const className = 'comment';

    useEffect(() => {
        renderData();
    }, []);

    const renderData = async() => {
        setCommentLoading(true);
        let commentObj = props.commentList.find((comment) => comment.id === props.userInteraction.linkId);
        setComment(commentObj);
        let activeUserObj = localStorage.getItem('activeUser');
        if(!!activeUserObj && activeUserObj !== 'undefined') {
            setActiveUser(JSON.parse(activeUserObj));
        }
        try {
            if(!!commentObj?.userId) {
                let user = await userInfoService.getUserById(commentObj?.userId);
                user = JSON.parse(user.body);
                setCommentUser(user);
            }
            if (commentObj?.type === 'File') {
                let fileObj = currentFiles[commentObj.fileId];
                if(!!fileObj) {
                    setFile(fileObj);
                }
            }
        } catch (err) {
            errorHandler.handleError(err);
        }
        setCommentLoading(false);
    }

    const getInitials = (string) => {
        if(!!string && string.length > 0) {
            var names = string?.split(' '),
                initials = names[0]?.substring(0, 1)?.toUpperCase();

            if (names?.length > 1) {
                initials += names[names?.length - 1]?.substring(0, 1)?.toUpperCase();
            }
            return initials;
        }
        return 'N/A';
    };

    const dataURLtoFile = (dataurl) => {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], { type: mime });
    }

    const downloadFile = async() => {
        try {
            downloadFileFromUrl(file?.publicUrl, file?.fileName);
        } catch (err) {
            errorHandler.handleError(err);
        }
    }

    return (
        <>
            {
                commentLoading ?
                    <Skeleton variant="rounded" width={210} height={60} />
                :
                    <div className={className + ' flex-column-flex-start'}>
                        <div className={className + '__content__top flex-row-center-space-between width-wfa'}>
                            <div className={className + '__content__top__user width-wfa'}>
                                {
                                    ((activeUserId === commentUser?.id) || (JSON.stringify(activeUserId) == commentUser?.id)) ?
                                        <div className={className + '__content__top__user__self flex-row-flex-start width-wfa'}>
                                            {
                                                !!activeUser?.photo && activeUser?.photo !== 'null' && activeUser?.photo !== '' ?
                                                    <img src={URL.createObjectURL(dataURLtoFile(activeUser?.photo))}
                                                        className={className + '__content__top__user__self__pic standard-profile-pic'} alt='profile'/>
                                                :
                                                    <Avatar sx={{ bgcolor: colorList[activeUser?.fullName?.charCodeAt(0) % colorList.length] + ' !important'}}>{getInitials(activeUser?.fullName)}</Avatar>
                                            }
                                            <div className={className + '__content__top__user__self__flex flex-row-flex-start-space-between width-wfa'}>
                                                <div className={className + '__content__top__user__self__flex__name'}>
                                                    {activeUser?.fullName}
                                                </div>
                                                <div className={className + '__content__top__user__self__flex grey-text sm-text'}>
                                                    { moment(new Date(comment?.timeStamp),'DD-MM-YYYY').fromNow() }
                                                </div>
                                            </div>
                                        </div>
                                    :
                                        comment.userType === 'reporterWhatsapp' ?
                                            <div className={className + '__content__top__user__whatsapp flex-row-flex-start-1vw-gap'}>
                                                <Avatar sx={{ bgcolor: colorList[props?.ticket?.createdByFullName?.charCodeAt(0) % colorList.length] + ' !important'}}>
                                                    {getInitials(props?.ticket?.createdByFullName)}
                                                </Avatar>
                                                <div className={className + '__content__top__user__whatsapp__t1 flex-row-center-1rem-gap'}>
                                                    {props?.ticket?.createdByFullName}
                                                    <WhatsAppLogo className={className + '__content__top__user__whatsapp__logo'}/>
                                                </div>
                                            </div>
                                        :
                                            comment.userType === 'reporterResolve' ?
                                                <div className={className + '__content__top__user__whatsapp flex-row-flex-start-1vw-gap'}>
                                                    <Avatar sx={{ bgcolor: colorList[props?.ticket?.createdByFullName?.charCodeAt(0) % colorList.length] + ' !important'}}>
                                                        {getInitials(props?.ticket?.createdByFullName)}
                                                    </Avatar>
                                                    <div className={className + '__content__top__user__whatsapp__t1 flex-row-center-1rem-gap'}>
                                                        {props?.ticket?.createdByFullName}
                                                    </div>
                                                </div>
                                            :
                                                <div className={className + '__content__top__user__other flex-row-flex-start-1vw-gap'}>
                                                    <ProfilePicture className={className + '__content__top__user__other__icon grey-text standard-profile-pic'}/>
                                                    <div className={className + '__content__top__user__whatsapp__t1 flex-row-center-1rem-gap'}>
                                                        AGENT
                                                    </div>
                                                </div>
                                }
                            </div>

                        </div>
                        {
                            props?.comment?.type === 'File' ?
                                <div className={className + '__content'}>
                                    <div className={className + '__content__bottom'}>
                                        {
                                            (file?.fileType?.indexOf('image') > -1) &&
                                            <div className={className + '__image flex-row-flex-start width-wfa'}>
                                                <div className={className + '__image__inner flex-column-flex-start width-wfa'}>
                                                    <img
                                                        src={file?.publicUrl}
                                                        className={className + '__image__display width-wfa'}
                                                        alt={file?.fileName}/>
                                                </div>
                                            </div>
                                        }
                                        {
                                            (file?.fileType?.indexOf('video') > -1) &&
                                            <div className={className + '__video flex-row-flex-start width-wfa'}>
                                                <div className={className + '__video__inner flex-column-flex-start width-wfa'}>
                                                    {
                                                        !!file?.file &&
                                                            <>
                                                                <video
                                                                    className={className + '__video__display width-wfa'}
                                                                    controls
                                                                    src={file?.publicUrl}
                                                                />
                                                            </>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        {
                                            (file?.fileType?.indexOf('pdf') > -1) &&
                                            <div className={className + '__pdf flex-row-flex-start width-wfa'}>
                                                <div className={className + '__pdf__inner flex-column-flex-start width-wfa'}>
                                                    <object data={file?.file} type='application/pdf' alt={file?.fileName}/>
                                                </div>
                                            </div>
                                        }
                                        <div className={className + '__file__name flex-row-center-1vw-gap'} onClick={() => downloadFile()}>
                                            <div className={className + '__file__name__fileName'}>
                                                {file?.fileName}
                                            </div>
                                            <Download className={className + '__file__name__download dashboard-icon standard-link'}/>
                                        </div>
                                    </div>
                                </div>
                            :
                            <div className={className + '__content'}>
                                <div className={className + '__content__bottom sm-text'}>
                                    {comment?.text}
                                </div>
                            </div>
                        }
                    </div>
            }
        </>
    );
}
